// ** React Imports
import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from '@layouts/VerticalLayout';

// ** Menu Items Array
import navigation from '@src/navigation/vertical';
import { useDispatch, useSelector } from 'react-redux';
import { getNavigationMenu } from '../views/MenuOrder/store';
import { Icon } from '@iconify/react';
import { VerticalShimmer } from './VerticalShimmer';

const fallBackMenu = [
    {
        id: '41ba1c77-12c8-4a43-9537-fdb3f65f53f3',
        title: 'Dashboard',
        dbId: '41ba1c77-12c8-4a43-9537-fdb3f65f53f3',
        navLink: '/dashboard',
        icon: 'akar-icons:dashboard',
        parentId: null,
        level: 1
    },
    {
        id: 'e01b04c9-78d0-4409-891c-ef8a28d54082',
        title: 'Settings',
        dbId: 'e01b04c9-78d0-4409-891c-ef8a28d54082',
        navLink: '',
        icon: 'icon-park-outline:setting-two',
        parentId: null,
        level: 2,
        children: [
            {
                id: '6e1046c4-27d9-40af-8fcf-0c151a4ff66d',
                title: 'Project',
                dbId: '6e1046c4-27d9-40af-8fcf-0c151a4ff66d',
                navLink: '/settings/project-setting',
                icon: 'ri:circle-line',
                parentId: 'e01b04c9-78d0-4409-891c-ef8a28d54082',
                level: 1
            },
            {
                id: 'd83d893e-243d-4cc8-833a-0bb9675c8709',
                title: 'Menu Order',
                dbId: 'd83d893e-243d-4cc8-833a-0bb9675c8709',
                navLink: '/settings/menu-order',
                icon: 'ri:circle-line',
                parentId: 'e01b04c9-78d0-4409-891c-ef8a28d54082',
                level: 2
            },
            {
                id: '9d806e66-6146-4800-a521-da924448b6ae',
                title: 'Email Templates',
                dbId: '9d806e66-6146-4800-a521-da924448b6ae',
                navLink: '/settings/email-templates',
                icon: 'ri:circle-line',
                parentId: 'e01b04c9-78d0-4409-891c-ef8a28d54082',
                level: 3
            },
            {
                id: 'a200d38c-d71d-44da-bcc8-7abe895e0843',
                title: 'Configuration',
                dbId: 'a200d38c-d71d-44da-bcc8-7abe895e0843',
                navLink: '/settings/configuration',
                icon: 'ri:circle-line',
                parentId: 'e01b04c9-78d0-4409-891c-ef8a28d54082',
                level: 4
            },
            {
                id: 'a6babab4-1c1d-4370-b23e-b25e623a065b',
                title: 'Module',
                dbId: 'a6babab4-1c1d-4370-b23e-b25e623a065b',
                navLink: '/settings/module',
                icon: 'ri:circle-line',
                parentId: 'e01b04c9-78d0-4409-891c-ef8a28d54082',
                level: 5
            }
        ]
    },
    {
        id: '5e1d0285-79b6-4d99-ade6-84cc9fbf32fb',
        title: 'Setup',
        dbId: '5e1d0285-79b6-4d99-ade6-84cc9fbf32fb',
        navLink: null,
        icon: 'gravity-ui:wrench',
        parentId: null,
        level: 3,
        children: [
            {
                id: '9d254493-df8f-4f4d-be22-8401433dfd25',
                title: 'Role & Rights',
                dbId: '9d254493-df8f-4f4d-be22-8401433dfd25',
                navLink: '/setup/role',
                icon: 'ri:circle-line',
                parentId: '5e1d0285-79b6-4d99-ade6-84cc9fbf32fb',
                level: 1
            },
            {
                id: '41a48d08-4d13-4cd8-bb74-3e383a2fbaf8',
                title: 'User',
                dbId: '41a48d08-4d13-4cd8-bb74-3e383a2fbaf8',
                navLink: '/setup/user',
                icon: 'ri:circle-line',
                parentId: '5e1d0285-79b6-4d99-ade6-84cc9fbf32fb',
                level: 2
            }
        ]
    },
    {
        id: '80e87ede-b2a4-4c74-8407-0cc9a54df052',
        title: 'Audit Logs',
        dbId: '80e87ede-b2a4-4c74-8407-0cc9a54df052',
        navLink: '/audit-logs',
        icon: 'hugeicons:tropical-storm-tracks-01',
        parentId: null,
        level: 4
    }
];

const VerticalLayout = (props) => {
    // const [menuData, setMenuData] = useState([])
    const dispatch = useDispatch();
    const menuData = useSelector((state) => state.menuOrder.navigationMenu);

    // ** For ServerSide navigation
    // useEffect(() => {
    //   axios.get(URL).then(response => setMenuData(response.data))
    // }, [])

    const [isVerticalShimmer, setIsVerticalShimmer] = useState(true);

    const mapMenuIcons = (menuItems) => {
        return menuItems.map((item) => {
            const newItem = {
                ...item,
                icon: item.icon ? <Icon icon={item.icon} width={20} height={20} /> : null
            };

            if (item?.children?.filter((f) => f.navLink != null)?.length > 0) {
                newItem.children = mapMenuIcons(item.children.filter((f) => f.navLink != null));
            } else {
                delete newItem.children;
            }
            return newItem;
        });
    };

    const updatedMenuData = menuData.length !== 0 ? mapMenuIcons(menuData?.filter((f) => f?.navLink != null)) : mapMenuIcons(fallBackMenu);

    const getAllMenus = async () => {
        setIsVerticalShimmer(true);
        await dispatch(getNavigationMenu());
        setIsVerticalShimmer(false);
    };

    useEffect(() => {
        getAllMenus();
    }, []);

    return (
        <>
            {isVerticalShimmer ? (
                <VerticalShimmer />
            ) : (
                <Layout menuData={updatedMenuData} {...props}>
                    <Outlet />
                </Layout>
            )}
        </>
    );
};

export default VerticalLayout;
